import React, { useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LanguageSelector from "./LanguageSelector";
import { useSocket } from "../Components/SocketContext";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { SOCKET_EVENT_TYPE, USER_CURRENT_PATH } from "../../helpers/common";
import useSocketHandlers from "./useSocketHandlers";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import { useMemo } from "react";
import { updateEmotionStatus } from "../../redux/actions/sessionAction";
import { updateEmotionStatusApi } from "../Services/emotion";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { isNavOpen } from "../../redux/slices/sessionSlice";

const PortalNavbar = () => {
  const { i18n } = useTranslation();
  const isopen = useSelector((state) => state.session.navOpen);
  const dispatch = useDispatch();
  const isTogleHide = useSelector((state) => state.session?.isTogleHide);

  const [dropbox, setDropBox] = useState(false);
  const { socket } = useSocket();
  const navigate = useNavigate();
  const loggedUser = useMemo(() => {
    return JSON.parse(localStorage.getItem("currentUser"));
  }, []);

  const isActiveEmotion = useSelector(
    (state) => state.session?.isEmotionActive?.status,
  );

  const {
    handleCancelSessionResponseForSender,
    handlerCancelSessionResponseForReceiver,
    handleSocketErr,
  } = useSocketHandlers();

  useEffect(() => {
    if (loggedUser && loggedUser.id) {
      const updateEmotionFn = async () => {
        try {
          await updateEmotionStatusApi(loggedUser.id, isActiveEmotion);
        } catch (error) {}
      };
      updateEmotionFn();
    }
  }, [loggedUser, isActiveEmotion]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("langName");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    if (socket) {
      socket.on(
        SOCKET_EVENT_TYPE.CLOSE_SESSION_SENDER_RESPONSE,
        handleCancelSessionResponseForSender,
      );
      socket.on(
        SOCKET_EVENT_TYPE.CLOSE_SESSION_RECEIVER_RESPONSE,
        handlerCancelSessionResponseForReceiver,
      );
      socket.on(SOCKET_EVENT_TYPE.ERROR, ({ data, message }) => {
        const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
        if (
          !loggedUser ||
          loggedUser?.session_id !== data?.sessionId ||
          loggedUser?.id !== data?.sender?.id ||
          !data?.sessionId ||
          !data?.sender
        ) {
          return;
        }
        toast.error(message);
      });
      return () => {
        socket.off(
          SOCKET_EVENT_TYPE.CLOSE_SESSION_SENDER_RESPONSE,
          handleCancelSessionResponseForSender,
        );
        socket.off(
          SOCKET_EVENT_TYPE.CLOSE_SESSION_RECEIVER_RESPONSE,
          handlerCancelSessionResponseForReceiver,
        );
        socket.off(SOCKET_EVENT_TYPE.ERROR);
      };
    }
  }, [
    socket,
    navigate,
    handleCancelSessionResponseForSender,
    handlerCancelSessionResponseForReceiver,
    handleSocketErr,
  ]);

  //child function
  const handleNavigate = (path, event) => {
    event.stopPropagation();
    if (path === "/setting") {
      setDropBox(!dropbox);
      // setNavOpen(true);
      dispatch(isNavOpen(true));
    } else {
      // setNavOpen(false);
      dispatch(isNavOpen(false));
      navigate(path);
    }
    const visitedPages = localStorage.getItem("visitedPages");
    let history = [];
    if (visitedPages) {
      history = JSON.parse(visitedPages);
    }
    // if (path !== USER_CURRENT_PATH.SETTING) {
    //   const newHistory = [...history, path];
    //   localStorage.setItem('visitedPages', JSON.stringify(newHistory));
    // }
    const excludedPaths = [
      USER_CURRENT_PATH.SETTING,
      USER_CURRENT_PATH.ABOUT_US,
      USER_CURRENT_PATH.CONTACT_US,
      USER_CURRENT_PATH.LEGAL_STUFF,
      USER_CURRENT_PATH.CREDIT,
    ];

    if (!excludedPaths.includes(path)) {
      const newHistory = [...history, path];
      localStorage.setItem("visitedPages", JSON.stringify(newHistory));
    }
  };

  //parent function
  const handleOpenSidebarNav = () => {
    // setNavOpen(true);
    dispatch(isNavOpen(true));
  };

  const checkEmotions = (e) => {
    let status = e.target.checked;
    dispatch(updateEmotionStatus({ userId: loggedUser?.id, status }));
  };

  const handleCloseToggle = () => {
    if (
      (isopen && window.location.pathname === USER_CURRENT_PATH.ABOUT_US) ||
      (isopen && window.location.pathname === USER_CURRENT_PATH.CONTACT_US) ||
      (isopen && window.location.pathname === USER_CURRENT_PATH.LEGAL_STUFF) ||
      (isopen && window.location.pathname === USER_CURRENT_PATH.CREDIT)
    ) {
      const visitedPages = localStorage.getItem("visitedPages");
      let history = [];
      if (visitedPages) {
        history = JSON.parse(visitedPages);
      }
      const lastIndexUrl = history?.[history?.length - 1];
      dispatch(isNavOpen(false));
      navigate(lastIndexUrl || "/");
    } else {
      // setNavOpen(false);
      dispatch(isNavOpen(false));
      setDropBox(false);
    }
  };

  return (
    <React.Fragment>
      <Navbar expand="lg" className="main-navbar">
        <div
          className="logo-main cur"
          onClick={(event) => handleNavigate("/", event)}
        >
          <img
            className="desktop-logo"
            src="/assets/image/Logo.svg"
            alt="login-logo"
          />
        </div>
        <div className="mobile-nav">
          <div className="toggleMenu">
            {!isopen && isTogleHide && (
              <div className="menu_btn">
                <p>Menu</p>
                <img
                  className="inline-block"
                  onClick={() => {
                    handleOpenSidebarNav();
                  }}
                  src="/assets/image/mob-menu.svg"
                  alt="menu"
                />
              </div>
            )}
            {isopen && (
              <div className="menu_btn">
                <p>Close</p>
                <img
                  src="/assets/image/close-btn.svg"
                  alt="close"
                  onClick={() => {
                    handleCloseToggle();
                  }}
                />
              </div>
            )}
          </div>
          <div className={`sideNav ${isopen ? "active" : ""} `}>
            <ul className="mob-menu">
              <li>
                <NavLink
                  to="#"
                  onClick={(event) => handleNavigate("/about-us", event)}
                >
                  {t("about")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="#"
                  onClick={(event) => handleNavigate("/setting", event)}
                >
                  {t("settings")}
                </NavLink>
                <ul className={`${dropbox ? "active" : ""} sub_menu`}>
                  {/* <li><LanguageSelector openNav={setNavOpen} /> */}
                  <li>
                    <LanguageSelector />
                  </li>
                  <li className="emotions">
                    {t("emotion")}
                    <Form.Check // prettier-ignore
                      type="switch"
                      id="custom-switch"
                      checked={isActiveEmotion}
                      onChange={checkEmotions}
                    />
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  to="#"
                  onClick={(event) => handleNavigate("/contact-us", event)}
                >
                  {t("contactus")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="#"
                  onClick={(event) => handleNavigate("/legal", event)}
                >
                  {t("legalstufftitle")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="#"
                  onClick={(event) => handleNavigate("/credit", event)}
                >
                  {t("credit")}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </Navbar>
    </React.Fragment>
  );
};

export default PortalNavbar;
